import SnackbarContent from '@mui/material/SnackbarContent';
import { styled } from '@mui/material/styles';

export const StyledSnackbarContent = styled(SnackbarContent)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: 'white',
  borderRadius: theme.spacing(1),
  maxWidth: 320,
  alignItems: 'flex-start',
  '& .MuiSnackbarContent-message': {
    minWidth: 0,
    flex: 1,
    overflow: 'hidden',
  },
  '& .MuiSnackbarContent-action': {
    flexShrink: 0,
  },
  '& .MuiIconButton-root': {
    opacity: 0,
    transition: 'opacity 0.2s',
  },
  '&:hover .MuiIconButton-root': {
    opacity: 1,
  },
}));
